import { Component } from '@angular/core';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-announcement-bar-settings',
  templateUrl: './announcement-bar-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpAnnouncementBarSettingsComponent extends OmpSectionSettings {
}
